import { FC } from 'react'
import './SelectState.scss'

export const PuertoRicoMunis = [
  { label: 'Adjuntas', value: 'Adjuntas' },
  { label: 'Aguada', value: 'Aguada' },
  { label: 'Aguadilla', value: 'Aguadilla' },
  { label: 'Aguas Buenas', value: 'Aguas Buenas' },
  { label: 'Aibonito', value: 'Aibonito' },
  { label: 'Añasco', value: 'Añasco' },
  { label: 'Arecibo', value: 'Arecibo' },
  { label: 'Arroyo', value: 'Arroyo' },
  { label: 'Barceloneta', value: 'Barceloneta' },
  { label: 'Barranquitas', value: 'Barranquitas' },
  { label: 'Bayamón', value: 'Bayamón' },
  { label: 'Cabo Rojo', value: 'Cabo Rojo' },
  { label: 'Caguas', value: 'Caguas' },
  { label: 'Camuy', value: 'Camuy' },
  { label: 'Canóvanas', value: 'Canóvanas' },
  { label: 'Carolina', value: 'Carolina' },
  { label: 'Cataño', value: 'Cataño' },
  { label: 'Cayey', value: 'Cayey' },
  { label: 'Ceiba', value: 'Ceiba' },
  { label: 'Ciales', value: 'Ciales' },
  { label: 'Cidra', value: 'Cidra' },
  { label: 'Coamo', value: 'Coamo' },
  { label: 'Comerío', value: 'Comerío' },
  { label: 'Corozal', value: 'Corozal' },
  { label: 'Culebra', value: 'Culebra' },
  { label: 'Dorado', value: 'Dorado' },
  { label: 'Fajardo', value: 'Fajardo' },
  { label: 'Florida', value: 'Florida' },
  { label: 'Guánica', value: 'Guánica' },
  { label: 'Guayama', value: 'Guayama' },
  { label: 'Guayanilla', value: 'Guayanilla' },
  { label: 'Guaynabo', value: 'Guaynabo' },
  { label: 'Gurabo', value: 'Gurabo' },
  { label: 'Hatillo', value: 'Hatillo' },
  { label: 'Hormigueros', value: 'Hormigueros' },
  { label: 'Humacao', value: 'Humacao' },
  { label: 'Isabela', value: 'Isabela' },
  { label: 'Jayuya', value: 'Jayuya' },
  { label: 'Juana Díaz', value: 'Juana Díaz' },
  { label: 'Juncos', value: 'Juncos' },
  { label: 'Lajas', value: 'Lajas' },
  { label: 'Lares', value: 'Lares' },
  { label: 'Las Marías', value: 'Las Marías' },
  { label: 'Las Piedras', value: 'Las Piedras' },
  { label: 'Loíza', value: 'Loíza' },
  { label: 'Luquillo', value: 'Luquillo' },
  { label: 'Manatí', value: 'Manatí' },
  { label: 'Maricao', value: 'Maricao' },
  { label: 'Maunabo', value: 'Maunabo' },
  { label: 'Mayagüez', value: 'Mayagüez' },
  { label: 'Moca', value: 'Moca' },
  { label: 'Morovis', value: 'Morovis' },
  { label: 'Naguabo', value: 'Naguabo' },
  { label: 'Naranjito', value: 'Naranjito' },
  { label: 'Orocovis', value: 'Orocovis' },
  { label: 'Patillas', value: 'Patillas' },
  { label: 'Peñuelas', value: 'Peñuelas' },
  { label: 'Ponce', value: 'Ponce' },
  { label: 'Quebradillas', value: 'Quebradillas' },
  { label: 'Rincón', value: 'Rincón' },
  { label: 'Río Grande', value: 'Río Grande' },
  { label: 'Sabana Grande', value: 'Sabana Grande' },
  { label: 'Salinas', value: 'Salinas' },
  { label: 'San Germán', value: 'San Germán' },
  { label: 'San Juan', value: 'San Juan' },
  { label: 'San Lorenzo', value: 'San Lorenzo' },
  { label: 'San Sebastián', value: 'San Sebastián' },
  { label: 'Santa Isabel', value: 'Santa Isabel' },
  { label: 'Toa Alta', value: 'Toa Alta' },
  { label: 'Toa Baja', value: 'Toa Baja' },
  { label: 'Trujillo Alto', value: 'Trujillo Alto' },
  { label: 'Utuado', value: 'Utuado' },
  { label: 'Vega Alta', value: 'Vega Alta' },
  { label: 'Vega Baja', value: 'Vega Baja' },
  { label: 'Vieques', value: 'Vieques' },
  { label: 'Villalba', value: 'Villalba' },
  { label: 'Yabucoa', value: 'Yabucoa' },
  { label: 'Yauco', value: 'Yauco' },
]

export const stateOptions = [
  {
    label: 'Alabama',
    value: 'AL',
  },
  {
    label: 'Alaska',
    value: 'AK',
  },
  {
    label: 'Arizona',
    value: 'AZ',
  },
  {
    label: 'Arkansas',
    value: 'AR',
  },
  {
    label: 'California',
    value: 'CA',
  },
  {
    label: 'Colorado',
    value: 'CO',
  },
  {
    label: 'Connecticut',
    value: 'CT',
  },
  {
    label: 'Delaware',
    value: 'DE',
  },
  {
    label: 'District of Columbia',
    value: 'DC',
  },
  {
    label: 'Florida',
    value: 'FL',
  },
  {
    label: 'Georgia',
    value: 'GA',
  },
  {
    label: 'Hawaii',
    value: 'HI',
  },
  {
    label: 'Idaho',
    value: 'ID',
  },
  {
    label: 'Illinois',
    value: 'IL',
  },
  {
    label: 'Indiana',
    value: 'IN',
  },
  {
    label: 'Iowa',
    value: 'IA',
  },
  {
    label: 'Kansas',
    value: 'KS',
  },
  {
    label: 'Kentucky',
    value: 'KY',
  },
  {
    label: 'Louisiana',
    value: 'LA',
  },
  {
    label: 'Maine',
    value: 'ME',
  },
  {
    label: 'Maryland',
    value: 'MD',
  },
  {
    label: 'Massachusetts',
    value: 'MA',
  },
  {
    label: 'Michigan',
    value: 'MI',
  },
  {
    label: 'Minnesota',
    value: 'MN',
  },
  {
    label: 'Mississippi',
    value: 'MS',
  },
  {
    label: 'Missouri',
    value: 'MO',
  },
  {
    label: 'Montana',
    value: 'MT',
  },
  {
    label: 'Nebraska',
    value: 'NE',
  },
  {
    label: 'Nevada',
    value: 'NV',
  },
  {
    label: 'New Hampshire',
    value: 'NH',
  },
  {
    label: 'New Jersey',
    value: 'NJ',
  },
  {
    label: 'New Mexico',
    value: 'NM',
  },
  {
    label: 'New York',
    value: 'NY',
  },
  {
    label: 'North Carolina',
    value: 'NC',
  },
  {
    label: 'North Dakota',
    value: 'ND',
  },
  {
    label: 'Ohio',
    value: 'OH',
  },
  {
    label: 'Oklahoma',
    value: 'OK',
  },
  {
    label: 'Oregon',
    value: 'OR',
  },
  {
    label: 'Pennsylvania',
    value: 'PA',
  },
  {
    label: 'Rhode Island',
    value: 'RI',
  },
  {
    label: 'South Carolina',
    value: 'SC',
  },
  {
    label: 'South Dakota',
    value: 'SD',
  },
  {
    label: 'Tennessee',
    value: 'TN',
  },
  {
    label: 'Texas',
    value: 'TX',
  },
  {
    label: 'Utah',
    value: 'UT',
  },
  {
    label: 'Vermont',
    value: 'VT',
  },
  {
    label: 'Virginia',
    value: 'VA',
  },
  {
    label: 'Washington',
    value: 'WA',
  },
  {
    label: 'West Virginia',
    value: 'WV',
  },
  {
    label: 'Wisconsin',
    value: 'WI',
  },
  {
    label: 'Wyoming',
    value: 'WY',
  },
]
const provinceOptions = [
  { value: 'AB', label: 'Alberta' },
  { value: 'BC', label: 'British Columbia' },
  { value: 'MB', label: 'Manitoba' },
  { value: 'NB', label: 'New Brunswick' },
  { value: 'NL', label: 'Newfoundland and Labrador' },
  { value: 'NS', label: 'Nova Scotia' },
  { value: 'NT', label: 'Northwest Territories' },
  { value: 'NU', label: 'Nunavut' },
  { value: 'ON', label: 'Ontario' },
  { value: 'PE', label: 'Prince Edward Island' },
  { value: 'QC', label: 'Quebec' },
  { value: 'SK', label: 'Saskatchewan' },
  { value: 'YT', label: 'Yukon' },
]
type StateSelectType = {
  value?: string
  disabled?: boolean
  onChange: (value: string) => void
  required?: boolean
  className?: string
  onBlur?: React.FocusEventHandler<HTMLSelectElement>
  country?: string
}

export const SelectState: FC<StateSelectType> = ({
  value,
  disabled,
  onChange,
  required,
  className,
  onBlur,
  country,
}) => {
  return (
    <select
      required={required}
      autoComplete="address-level1"
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      data-testid="state-select"
      className={`SelectState text-grey-500 border-tint-gray-200 w-full border p-2 pr-3 focus:!ring ${
        className || ''
      }`}
      disabled={disabled}
      onBlur={onBlur}
    >
      {!value && (
        <option value="" disabled>
          Select{' '}
          {(country === 'Canada' && 'province') ||
            (country === 'United States of America ' && 'state') ||
            (country === 'Puerto Rico' && 'municipality')}
        </option>
      )}
      {country === 'United States of America' &&
        stateOptions.map(({ value, label }) => (
          <option key={value} value={value} data-testid={`option-${value}`}>
            {label}
          </option>
        ))}
      {country === 'Canada' &&
        provinceOptions.map(({ value, label }) => (
          <option key={value} value={value} data-testid={`option-${value}`}>
            {label}
          </option>
        ))}
      {country === 'Puerto Rico' &&
        PuertoRicoMunis.map(({ value, label }) => (
          <option key={value} value={value} data-testid={`option-${value}`}>
            {label}
          </option>
        ))}
    </select>
  )
}
